import styled from "styled-components";

export const WarningModalStyled = styled.div`
  background-color: #fff;
  border-radius: 20px;
  padding: 32px 42px 24px 42px;
  h2 {
    font-weight: 500;
    font-size: 26px;
  }
  button {
    width: 100px;
  }
`;
